export const domainApiUrl = 'https://lf1ybbxaj5.execute-api.us-east-1.amazonaws.com/sandbox';
export const appHome = 'https://sandbox.correctionsrecordssearch.com';
export const productKey = 'inmate-search';

export const environment = {
  name: "sandbox",
  production: false,
  oidc: {
    clientId: '0oaif2t0slGMlOFj71d7',
    issuer: 'https://login.warrants.cloud/oauth2/ausde1i638HRXc8gk1d7',
    redirectUri: `${appHome}/callback`,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true
  },
  userApiUrl: `${domainApiUrl}/user`,
  sessionTimeoutSettings: {
    warningDurationMs: 5 * 60 * 1000, // 5 minutes
    inactivityDurationMs: 30 * 60 * 1000 // 30 minutes
  },
  ServiceApiUrl: domainApiUrl,
  canHostInBrowser: true,
  jppAdminBaseUrl: "https://qa-cloud-services.tylerapp.com",
  forceOutageBanner: false,
  outageBannerSeverity: 'info',
  outageBannerConfigUrl: 'https://sandbox.correctionsrecordssearch.com/status/outage-banner.json',
  // Cloudflare Turnstile site key (public). Obtain from the Cloudflare dashboard
  // -> Turnstile -> <this environment's widget>. The matching secret key lives
  // server-side (Lambda) and is never exposed here. Leave as a placeholder until
  // provisioned.
  turnstile: {
    siteKey: '0x4AAAAAAD7dtcb_vHUXgm6U'
  }
};